// This file is auto-generated by scripts/generate-version.js
// Do not edit manually - it will be overwritten on build

export const version = {
  gitCommit: '93c77e6e3',
  buildTime: '2026-11-04T12:26:48.305Z',
} as const;
